module.exports = __webpack_public_path__ + "media/images/newsletter-phone@2x-8bda214c8b53e503c0feeec5f3170452.png";